import { InlineLink, SectionAlert, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

const UnusualEventBanner = () => {
  const { t } = useTranslation(['Disconnect', 'Global']);

  return (
    <SectionAlert
      showIcon={false}
      variant="infoSecondary"
      className={styles['sectionAlert']}
    >
      <div>
        <Txt component="span" variant="bodySmallBold">
          {t('survey.alert.question')}
        </Txt>
        <Txt component="span" variant="bodySmallRegular">
          {t('survey.alert.callUsAt')}
        </Txt>
        <Txt component="span" variant="bodySmallRegular">
          <InlineLink
            variant="primary"
            className={styles['customerSupportTelLink']}
            href={`tel:${t('Global:callCustomerSupportPhoneNumber')}`}
          >
            {t('Global:callCustomerSupportPhoneNumberDisplay')}
          </InlineLink>
        </Txt>
        <Txt component="span" variant="bodySmallRegular">
          {t('survey.alert.toGetStarted')}
        </Txt>
      </div>
    </SectionAlert>
  );
};

export default UnusualEventBanner;
